import Fuse from 'fuse.js';
const fuseOptions = {
  findAllMatches: true,
  keys: ['label']
};
export const lookUpInputValueFromFetchedOptions = ({
  items,
  inputValue,
  setOptions,
  minLength
}) => {
  const fuseSearch = new Fuse(items, fuseOptions);
  const result = fuseSearch.search(inputValue);
  if (result.length === 0 && inputValue.length > minLength) {
    setOptions(prevItems => [...prevItems, {
      label: `${inputValue} (Create new)`,
      value: inputValue
    }]);
  }
};